import { render, staticRenderFns } from "./AvContractObjectAndDurationForm.vue?vue&type=template&id=2b566e3f&"
import script from "./AvContractObjectAndDurationForm.vue?vue&type=script&lang=js&"
export * from "./AvContractObjectAndDurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AvContractObjectAndDurationForm.vue"
export default component.exports